///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum ProductsTabs {
    CONFIGURATION = 'configuration',
    COMMON = 'common',
    EH_PARTS = 'eh_parts',
    EH_SERVICES = 'eh_services',
    MH_PARTS = 'mh_parts',
    MH_SERVICES = 'mh_services',
    TG_MH_PARTS = 'tg_mh_parts',
    TG_MH_SERVICES = 'tg_mh_services'
}
